import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

/**
 * Layout wraps every page in a consistent shell: a fixed Header at the
 * top, the routed page content in the middle, and a Footer at the
 * bottom. App.js renders <Layout> once around the <Routes>, so every
 * page automatically gets the same navigation and footer.
 *
 * The Admin Dashboard is the one exception: it has its own self-contained
 * sidebar + topbar shell (a different "app within the app"), so layering
 * the public Header/Footer on top of it would visually clash with its
 * fixed sidebar. Layout detects that route and renders the page on its
 * own, while every other route still passes through the normal shell.
 */
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin-dash");

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header />
      <main style={{ flex: 1, paddingTop: "4rem" }}>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
